import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  languageSwitcherWrapper: {
    position: 'relative'
  },
  languageSwitcherButton: {
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    padding: theme.spacing(0, 1),
    border: 0,
    transition: 'all 0.3s ease-in-out',
    display: 'flex !important',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    '& svg': {
      fontSize: theme.typography.pxToRem(18),
      marginLeft: theme.spacing(0.25)
    },
    '&.mobile': {
      fontSize: theme.typography.pxToRem(16),
      color: 'rgba(255, 255, 255, 0.5)',
      padding: theme.spacing(0),
      '& svg': {
        fontSize: theme.typography.pxToRem(23)
      }
    },
    '&:hover, &:focus': {
      color: theme.palette.primary.light,
      outline: 'none'
    }
  }
}))
